<section class="section1">
	<div class="container">
		<div class="row">
			<div class="col-xl-12 col-md-10 col-sm-11 col-11 mx-auto semi">
				<h1 class="size90 textcolor2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Commitment</h1>
				<h1 class="size90 textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">to your Privacy
					Policy</h1>
				<div class="list">
					<h3 class="size53 textcolor1 medium mb30 mt-4" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">Introduction</h3>
					<ul class="mb-2 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<li class="mb-2 size18 py-2 lufgasemibold"> Welcome to Pixtar Branding Services LLC.</li>
						<li class="mb-2 size18 py-2 "> Pixtar Branding Services LLC (“us”, “we”, or “our”) operates
							<span class="lufgasemibold">
								<a class="textcolor1" href="https://pixtar.ae">https://pixtar.ae</a>
							</span>
							(hereinafter referred to as
							<span class="lufgasemibold">“Service”</span>).
						</li>
						<li class="mb-2 size18 py-2 "> This Privacy Policy governs your visit to <span class="lufgasemibold"><a
									class="textcolor1" href="https://pixtar.ae">https://pixtar.ae</a></span>, explaining how we
							collect, safeguard, and
							disclose information resulting from your use of our Service.
						</li>
						<li class="mb-2 size18 py-2 ">We use your data to provide and improve our Service. By using our Service, you
							agree
							to the collection and
							use of information in accordance with this policy. Unless otherwise defined, terms in this
							Privacy Policy have the same meanings as those in our Terms and Conditions.
						</li>
						<li class="mb-2 size18 py-2 "> Our Terms and Conditions (“Terms”) govern all use of our Service and,
							together with
							this Privacy Policy,
							constitute your agreement with us (“Agreement”).
						<li>
					</ul>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>
				<div class="list2">
					<h3 class="size53 textcolor1 medium mb30" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						Definations</h3>
					<!-- <p class="size18 weight600" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Welcome to Pixtar
					Branding Services LLC.</p> -->
					<ul class="mb-5" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<li class="mb-2 size18"> <span class="lufgasemibold">Service</span> refers to the website https://pixtar.ae
							operated by Pixtar Branding Services LLC.</li>
						<li class="mb-2 size18"> <span class="lufgasemibold">Personal Data</span> means any information that relates
							to
							an identified or identifiable individual.</li>
						<li class="mb-2 size18"> <span class="lufgasemibold">Usage Data</span> refers to information collected
							automatically, either through Service use or Service infrastructure (e.g., page visit durations).</li>
						<li class="mb-2 size18"> <span class="lufgasemibold">Cookies</span> are small files stored on your device
							(computer or mobile device).</li>
						<li class="mb-2 size18"> <span class="lufgasemibold">Data Controller</span> means the natural or legal
							person
							responsible for determining the purposes and means of processing personal data. For this Privacy Policy,
							we are the Data Controller.</li>
						<li class="mb-2 size18"> <span class="lufgasemibold">Data Processors (Or Service Providers)</span>are third
							parties who process data on our behalf to make our Service more effective.</li>
						<li class="mb-2 size18"> <span class="lufgasemibold">Data Subject</span> refers to any living individual
							whose
							personal data is being processed.</li>
						<li class="mb-2 size18"> <span class="lufgasemibold">User</span> refers to the individual using our Service,
							who
							corresponds to the Data Subject.</li>
					</ul>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium mb30" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						Introduction Collection and Use</h3>
					<!-- <p class="size18 weight600" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Welcome to Pixtar
					Branding Services LLC.</p> -->
					<p class="py-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">We collect
						different types of information for various purposes, to provide and
						enhance our Service.</p>
					<!-- <li class="mb-2 size18">We collect different types of information for various purposes, to provide and
						enhance our Service.</li> -->
					<p class="mb-2 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"> <span
							class="lufgasemibold">Types of Data Collected:</span></p>

					<div class="py-4">
						<p class="size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"> <span
								class="lufgasemibold">Personal Data </span> </p>
						<p class="py-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							While using our Service, we may request certain personally identifiable information
							to contact or identify you. Personally identifiable information may include, but is not limited to:
						</p>
						<ul class="mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<li class="mb-2 size18">Email Address</li>
							<li class="mb-2 size18">Usage</li>
							<li class="mb-2 size18">Data Cookies</li>
						</ul>
					</div>

					<div class="py-4">
						<p class="size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"> <span
								class="lufgasemibold">Usage Data </span> </p>
						<p class="py-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							We may collect information that your browser sends during visits to our Service or when you access the
							Service via a mobile device. This may include:
						</p>
						<ul class="mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<li class="mb-2 size18">Your Device’s Internet Protocol (Ip) Address</li>
							<li class="mb-2 size18">Browser Type And Version</li>
							<li class="mb-2 size18">Pages Visited</li>
							<li class="mb-2 size18">Visit Timestamps</li>
							<li class="mb-2 size18">Time Spent On Pages</li>
							<li class="mb-2 size18">Device Identifiers And Diagnostic Data</li>
						</ul>
					</div>


					<div class="py-4">
						<p class="size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"> <span
								class="lufgasemibold">Tracking Cookies Data</span> </p>
						<p class="py-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							We use cookies to monitor and track activity on our Service and store certain information. You can control
							cookie settings through your browser, but disabling cookies may limit certain Service functionalities.
						</p>
						<p class="py-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							Types of Cookies we use:
						</p>
						<ul class="mb-2 ul-cus-de" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<li class="mb-2 size18"><span class="lufgasemibold">Session Cookies: </span>For Service Operation.</li>
							<li class="mb-2 size18"><span class="lufgasemibold">Preference Cookies: </span>To Remember User Settings
								And
								Preferences.</li>
							<li class="mb-2 size18"><span class="lufgasemibold">Security Cookies: </span>For Enhanced Security.</li>
							<li class="mb-2 size18"><span class="lufgasemibold">Advertising Cookies: </span>To Serve Personalized
								Advertisements.</li>
						</ul>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Use of
						Data</h3>

					<div class="py-4">
						<p class="pb-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							Pixtar Branding Services LLC uses collected data for purposes including:
						</p>
						<ul class="mb-2 ul-cus-de" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<li class="mb-2 size18">Providing And Maintaining The Service.</li>
							<li class="mb-2 size18">Communicating Changes Or Updates To The Service.</li>
							<li class="mb-2 size18">Enabling Participation In Interactive Features.</li>
							<li class="mb-2 size18">Offering Customer Support.</li>
							<li class="mb-2 size18">Conducting Analysis To Improve The Service.</li>
							<li class="mb-2 size18">Monitoring Service Usage.</li>
							<li class="mb-2 size18">Addressing Technical Issues.</li>
							<li class="mb-2 size18">Sending Promotional Materials (With An Opt-Out Option).</li>

						</ul>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Data
						Retention</h3>

					<div class="py-4">
						<p class="size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							We retain your Personal Data only as long as necessary for purposes outlined in this Privacy Policy. We
							may retain data longer to:
						</p>
						<ul class="mb-2 ul-cus-de" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<li class="mb-2 size18">Comply With Uae Legal Requirements. </li>
							<li class="mb-2 size18">Resolve Disputes.</li>
							<li class="mb-2 size18">Enforce Agreements And Policies.</li>
						</ul>
						<p class="size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							Usage Data may be retained for shorter durations unless used to bolster security or improve Service
							functionality.
						</p>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Data
						Transfer</h3>

					<div class="py-4">
						<p class="size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							Your information, including Personal Data, may be transferred to and stored on computers outside your
							jurisdiction. By using our Service, you consent to such transfers, which will be safeguarded in compliance
							with UAE data protection laws.
						</p>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						Disclosure of Data</h3>
					<div class="py-4">
						<p class="mb-2 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"> <span
								class="lufgasemibold">Legal Requirements</span></p>
						<p class="py-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							We may disclose Personal Data if required to:
						</p>
						<ul class="mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<li class="mb-2 size18">Comply With Uae Laws Or Government Requests.</li>
							<li class="mb-2 size18">Protect And Defend Our Legal Rights.</li>
							<li class="mb-2 size18">Investigate Suspected Misconduct.</li>
						</ul>
						<p class="mb-2 mt-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"> <span
								class="lufgasemibold">Business Transfers</span></p>
						<p class="py-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							If Pixtar Branding Services LLC is involved in a merger, acquisition, or sale, your data may be
							transferred to the new entity. </p>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium " data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						Security of Data</h3>
					<div class="py-4">
						<!-- <p class="mb-2 size18"> <span class="weight600">Legal Requirements</span></p> -->
						<p class="size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							We implement commercially reasonable measures to protect your data. However, no method of data
							transmission or storage is 100% secure, and we cannot guarantee absolute security. </p>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium " data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Your
						Data Protection Rights <br>(Applicable Laws)</h3>
					<div class="py-4">
						<p class="mb-2 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Under UAE laws, you
							have the right to:</p>
						<ul class="mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<li class="mb-2 size18">Request Access To Data We Hold About You.</li>
							<li class="mb-2 size18">Correct Inaccuracies In Your Data.</li>
							<li class="mb-2 size18">Request Data Deletion, Subject To Legal And Contractual Restrictions.</li>
							<li class="mb-2 size18">Withdraw Consent Where Applicable.</li>
						</ul>

						<p class="py-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							For such requests, contact us at
							<span class="lufgasemibold">hey&#64;pixtar.ae</span>.
						</p>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium " data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Service
						Providers</h3>
					<div class="py-4">

						<p class="pb-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							We may use third-party companies for:
						</p>
						<ul class="mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<li class="mb-2 size18">Analytics (E.G., Google Analytics) </li>
							<li class="mb-2 size18">Payments (E.G., Stripe)</li>
						</ul>
						<p class="py-4 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							These providers are obligated to safeguard your data and process it only on our instructions.
						</p>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>


				<div class="list2">
					<h3 class="size53 textcolor1 medium " data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						Children’s Privacy</h3>
					<div class="py-4">
						<!-- <p class="mb-2 size18"> <span class="weight600">Legal Requirements</span></p> -->
						<p class="size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							Our Service is not intended for children under 13. We do not knowingly collect personal data from
							children. If we become aware of such data collection, we will take immediate action to remove the data.
						</p>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium " data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Changes
						to This Privacy Policy</h3>
					<div class="py-4" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<!-- <p class="mb-2 size18"> <span class="weight600">Legal Requirements</span></p> -->
						<p class="size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							We may update this Privacy Policy from time to time. Changes will be notified via email or on this page.
							Please review this page periodically for updates.
						</p>
					</div>
				</div>
				<div class="customborder textcolor1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"></div>

				<div class="list2">
					<h3 class="size53 textcolor1 medium " data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">Contact
						Us</h3>
					<div class="py-4">
						<p class="mb-2 size18" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">For questions or
							concerns regarding this Privacy Policy, contact us at:</p>
						<ul class="mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<li class="mb-2 size18"><a href="mailto:hey@pixtar.ae"><span class="lufgasemibold">Email:</span>
									hey&#64;pixtar.ae</a></li>
							<li class="mb-2 size18"><a href="https://www.pixtar.ae"><span class="lufgasemibold">Website:</span>
									www.pixtar.ae</a></li>
						</ul>
					</div>
				</div>

			</div>
		</div>
	</div>
</section>
